/* eslint @typescript-eslint/naming-convention: 0 */
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export interface VideoPlayParams {
  section_id: string;
  video_id: string;
  position: number;
  screen_name: string;
}

export const sendGAWabunkaVideoPlayEvent = (params: { sectionId: string; videoId: string; position: number; screenName: string }) => {
  sendWabunkaGAEvent('video_play', {
    section_id: params.sectionId,
    video_id: params.videoId,
    position: params.position,
    screen_name: params.screenName,
  });
};
